import {PromotionFormState} from 'models/CreatePromotion'
import React from 'react'

type TemplateType = {
 template_text?: string
}

type Props = {
 formState?: PromotionFormState
 selectedTemplate?: TemplateType | null
}
const PromotionImageSection = ({
 formState,
 selectedTemplate,
}: Props) => {
 const renderStyledText = (text: string) => {
  const parts = text.split(/(<[^>]+>)/g)

  return parts.map((part, index) => {
   const isVariable = /^<[^>]+>$/.test(part)

   return (
    <span
     key={index}
     className={
      isVariable
       ? 'text-yellow-400 font-semibold'
       : 'text-white'
     }
    >
     {part}
    </span>
   )
  })
 }

 return (
  <div
   className='bg-gray-100 p-4 h-[424px] rounded-2xl flex justify-center mx-auto'
   style={{width: '65%'}}
  >
   <div
    className='relative w-full rounded-2xl overflow-hidden text-white'
    style={{
     backgroundImage: `url(${formState?.image || ''})`,
     backgroundSize: 'cover',
     backgroundPosition: 'center',
     backgroundRepeat: 'no-repeat',
    }}
   >
    <div className='absolute inset-0 flex flex-col justify-between'>
     <div className='flex flex-col items-center justify-center px-6 pt-10 text-center'>
      {formState?.product_image_url ? (
       <div className='bg-white rounded-2xl p-3 shadow-md mb-4'>
        <img
         src={formState?.product_image_url || ''}
         alt='product'
         className='w-24 object-contain'
        />
       </div>
      ) : (
       <div className='bg-white rounded-2xl p-3 shadow-md mb-4 w-[84px] h-[84px]'></div>
      )}

      <div className='flex gap-2 w-full justify-center min-w-0'>
       <h3 className='text-sm md:text-base font-semibold truncate max-w-[70%]'>
        {formState?.productName}
       </h3>

       {formState?.productVariantSize && (
        <p className='text-sm md:text-base font-semibold shrink-0'>
         {formState?.productVariantSize}
        </p>
       )}
      </div>

      <p className='text-yellow-400 font-semibold text-sm mt-2'>
       {'<price>'}
      </p>
     </div>

     <div className='px-6 pb-8 text-center'>
      <div className='whitespace-pre-line text-xs sm:text-sm leading-5 sm:leading-6'>
       {renderStyledText(
        selectedTemplate?.template_text || ''
       )}
      </div>
     </div>
    </div>
   </div>
  </div>
 )
}

export default PromotionImageSection
